import { render, staticRenderFns } from "./license-expired.vue?vue&type=template&id=2e51a99d&scoped=true&"
import script from "./license-expired.vue?vue&type=script&lang=js&"
export * from "./license-expired.vue?vue&type=script&lang=js&"
import style0 from "./license-expired.vue?vue&type=style&index=0&id=2e51a99d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51a99d",
  null
  
)

export default component.exports